<template>
  <div class="table-responsive">
    <table class="table table-data min-w-table">
      <thead>
        <tr>
          <th
            class="table-caption"
            colspan="7"
          >
            <h3 v-html="date" />
          </th>
        </tr>
        <tr>
          <th
            class="sm:w-1/6"
            v-text="'Member'"
          />
          <th
            class="sm:w-32"
            v-text="'Details'"
          />
          <th v-text="'Groups'" />
          <th
            class="sm:w-1/6"
            v-text="'Permissions'"
          />
          <th
            v-if="paymentsEnabled && membershipFee.hasOwnProperty('attributes')"
            class="sm:w-32"
            v-text="membershipFee.attributes.title"
          />
          <th
            class="sm:w-32"
            v-text="'Approve'"
          />
          <th class="sm:w-24" />
        </tr>
      </thead>
      <tbody>
        <tr
          is="AccessRequest"
          v-for="accessRequest in accessRequests"
          :key="accessRequest.uuid"
          :access-request="accessRequest"
          :approve-all="approveAll"
          @processing="$emit('processing')"
          @doneProcessing="$emit('doneProcessing')"
        />
      </tbody>
    </table>
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import AccessRequest from './AccessRequest'

export default {
  name: 'AccessRequestDay',
  components: {
    AccessRequest,
  },
  props: {
    accessRequestDay: {
      type: Array,
      required: true,
    },
    approveAll: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
    }),
    accessRequests() {
      return this.accessRequestDay
    },
    date() {
      return `Requested on ${this.$date.toMomentDateFormat(this.accessRequestDay[0].attributes.created_at)}`
    },
    paymentsEnabled(){
      return this.$root.Union.payments_enabled
    },
  },
}
</script>
